import Select from '../Select/Select';
import Tools from '../Tools/Tools';
/**
 * Vytváření nového webu.
 */
class Webs {
	constructor() {
		this.section = document.querySelector('.Wizard--web .Form-box');
		// Během přidávání a odebírání filtrů je nutné pracovat s instancemi Selectu,
		// takže jsou zde uchovávány.
		this.filterSelects = [];

		if (this.section) {
			// První hodnota select boxu pro výběr kopie kódu ve formuláři.
			// Ostatní options jsou podle počtu řádků filtru 1, 2, 3 apod..
			this.copyCodeSelectOption = [-1, 'Žádné'];
			this.setListeners();
		}

		this.chooseTypeForm = document.getElementById('Wizard-form-chooseType');

		if (this.chooseTypeForm) {
			this.listenOnWebType();
		}
	}

	/**
	 * Přesměruje uživatele na stránku vytvářní zvoleného webu.
	 */
	setWebsCreateLocation() {
		document.location =
			this.chooseTypeForm.getAttribute('action') + '/' + document.querySelector('input[name=type]:checked').value;
	}

	/**
	 * Pokud uživatel vybere typ webu a odešle formulář,
	 * tak sestavím url /webs/create/(software | rtb | software).
	 * Nebo dvakrát kline na boxík.
	 */
	listenOnWebType() {
		this.chooseTypeForm.addEventListener('submit', (e) => {
			e.preventDefault();
			this.setWebsCreateLocation();
		});

		Array.from(document.getElementsByClassName('Wizard-chooseType-box')).forEach((box) => {
			if (!box.classList.contains('Wizard-chooseType-box--mainVideo')) {
				box.addEventListener('dblclick', () => {
					this.setWebsCreateLocation();
				});
			}
		});
	}

	/**
	 * Nastavý potřebné listenery.
	 */
	setListeners() {
		// Pokud uživatel vybere při přidávání nového webu 'Zobrazovat reklamu nevhodnou pro děti',
		// tak bude možnost zobrazovat v čase 22:00 - 6:00 disabled.
		// TODO: delete !!!
		/* Array.from(this.section.querySelectorAll('input[name="adult"]')).forEach((input) => {
			input.addEventListener('click', (e) => {
				let input = document.querySelector('input[value="only-evening-hours"]');
				if (e.target.value === 'not-for-kids') {
					input.disabled = false;
				} else {
					input.disabled = true;
					input.checked = false;
				}
			});
		}); */

		// Uložení často používaného těla tabulky.
		this.tbody = this.section.querySelector('.Filter-table tbody');

		// Přidávání nových řádků do filtru.
		this.section.querySelector('.Filter-add').addEventListener('click', () => {
			this.createNewFilterLine();
		});
	}

	/**
	 * Voláno pokud uživatel vybere kopii kódu pomocí select boxu.
	 * @param {string} selected
	 * @param {*} that Představuje 'this' z objektu Select.
	 */
	onChangeSelectCode(selected, that) {
		// Opravdovému (schovanému selectu) nastaví vybranou hodnotu.
		that.getElement().nextElementSibling.setAttribute('value', selected);
		that.setSelectOption(selected);
		that.toggleSelect();
	}

	/**
	 * Vytvoří options pro opravdový select tvořenen elementy select, option.
	 * Tento select je schován pomocí CSS a slouží pouze pro odesílání na server.
	 * @return {string} Vrací string s options selectu.
	 */
	getRealSelectOptions() {
		// eslint-disable-next-line typescript-eslint/restrict-template-expressions
		let options = `<option value='${this.copyCodeSelectOption[0]}'>${this.copyCodeSelectOption[1]}</option>`;

		for (let i = 0; i < this.tbody.children.length; i++) {
			// eslint-disable-next-line typescript-eslint/restrict-template-expressions
			options += `<option value='${i + 1}'>${i + 1}</option>`;
		}

		return options;
	}

	/**
	 * Options pro viditelný select tvořený pomocí divů (lze lépe stylovat).
	 * @param {number} index Index select boxu => nelze vybírat kopii kódu na sebe sama.
	 * @return {[]} Vrací pole s options [hodnota, název].
	 */
	getFakeSelectOptions(index = -1) {
		const options = [this.copyCodeSelectOption];

		for (let i = 0; i < this.tbody.children.length; i++) {
			if (i !== index) {
				options.push([i + 1, i + 1]);
			}
		}

		return options;
	}

	/**
	 * Options obsahuje odkaz na každý filter.
	 * V případě odstranění řádku je nutné option updatovat,
	 * protože jinak vybraný option může odkazovat na neexistující filtr.
	 */
	updateSelectsOption() {
		// Update fake selectů. (divy)
		this.filterSelects.forEach((select, index) => {
			select.setNewOptions(this.getFakeSelectOptions(index + 1));
		});

		// Update opravdových selectů. (select/option)
		// Uvnitř fake select boxů jsou už správně nastavené vybrané hodnoty,
		// tak je nastavím i do opravdových selectů.
		Array.from(this.section.getElementsByTagName('select')).forEach((select) => {
			select.setAttribute(
				'value',
				select.parentElement.querySelector('.Select-option.is-selected').getAttribute('value'),
			);
		});
	}

	/**
	 * Odstraní danou řádků.
	 * @param {Event} e Event.
	 */
	removeFilterLine(e) {
		// e.target představuje tlačítko 'Odebrat kód', které je zanořené uvnitř řádky,
		// která bude odstraněna.
		const row = e.target.parentElement.parentElement;

		if (row.tagName === 'TR') {
			// - 1 protože první filtr je pevný (nelze mazat).
			this.filterSelects.splice(Array.from(this.tbody.children).indexOf(row) - 1, 1);

			this.tbody.removeChild(row);
			this.updateSelectsOption();
		}
	}

	/**
	 * Vytvoří nový řádek filtru.
	 */
	createNewFilterLine() {
		const tr = document.createElement('tr');
		// Inputy v každém řádku mají jiné indexy.
		const lineIndex = this.tbody.children.length + 1;

		const id = Tools.createElement('td');

		const codeName = Tools.createElement('td', {
			/* eslint-disable typescript-eslint/restrict-template-expressions */
			innerHTML: `
			<label>
				<input type="text" name="zones.${lineIndex}.name" placeholder="Název kódu">
			</label>`,
			/* eslint-enable typescript-eslint/restrict-template-expressions */
		});

		const advertisementCode = Tools.createElement('td', {
			/* eslint-disable typescript-eslint/restrict-template-expressions */
			innerHTML: `
			<label>
				<input type="text" name="zones.${lineIndex}.max_ad_count" placeholder="Název kódu">
			</label>`,
			/* eslint-enable typescript-eslint/restrict-template-expressions */
		});

		const topCode = Tools.createElement('td', {
			/* eslint-disable typescript-eslint/restrict-template-expressions */
			innerHTML: `
			<label>
				<input type="radio" name="zones.top_zone" value="${lineIndex}">
				<span></span>
			</label>`,
			/* eslint-enable typescript-eslint/restrict-template-expressions */
		});

		// Obsahuje opravdový select (select, option), který je schovaný a fake (divy).
		const selectsWrap = document.createElement('td');
		const selectFake = new Select();

		selectFake.initSelectWithParams(
			this.getFakeSelectOptions(),
			this.onChangeSelectCode.bind(this),
			this.copyCodeSelectOption[0], // Výchozí hodnota.
		);

		this.filterSelects.push(selectFake);
		const selectReal = Tools.createElement('select', {
			innerHTML: this.getRealSelectOptions(),
			// eslint-disable-next-line typescript-eslint/restrict-template-expressions
			name: `zones.${lineIndex}.original_zone_id`,
			value: this.copyCodeSelectOption[0],
		});

		Tools.appendChilds(selectsWrap, selectFake.getElement(), selectReal);

		const sitelinks = Tools.createElement('td', {
			/* eslint-disable typescript-eslint/restrict-template-expressions */
			innerHTML: `
			<label>
				<input type="checkbox" name="zones.${lineIndex}.sitelinks_enabled">
				<span></span>
			</label>`,
			/* eslint-enable typescript-eslint/restrict-template-expressions */
		});

		const productAdvertisement = Tools.createElement('td', {
			/* eslint-disable typescript-eslint/restrict-template-expressions */
			innerHTML: `
			<label>
				<input type="checkbox" name="zones.${lineIndex}.product_ad">
				<span></span>
			</label>`,
			/* eslint-enable typescript-eslint/restrict-template-expressions */
		});

		// Tlačítko pro odstranění přidruženého řádku.
		const filterRemove = Tools.createElement('td', {
			innerHTML: `
				<span class="Filter-remove">Odebrat kód</span>`,
		});

		filterRemove.addEventListener('click', this.removeFilterLine.bind(this));

		// Kompletace řádku.
		Tools.appendChilds(
			tr,
			id,
			codeName,
			advertisementCode,
			topCode,
			selectsWrap,
			sitelinks,
			productAdvertisement,
			filterRemove,
		);

		this.tbody.appendChild(tr);
		this.updateSelectsOption();
	}
}

export default Webs;
